import { apiFetch } from './client';

export interface ChangelogEntry {
  version: string;
  date: string;
  title: string;
  highlights: string[];
  notify: boolean;
  channelUrl?: string;
}

export interface ChangelogStatus {
  entries: ChangelogEntry[];
  latestNotifiableVersion: string | null;
  seenVersion: string | null;
  shouldNotify: boolean;
  notifyDisabled: boolean;
}

export const changelogApi = {
  getStatus: () => apiFetch<ChangelogStatus>('/api/changelog'),
  markSeen: () =>
    apiFetch<{ ok: boolean }>('/api/changelog/seen', {
      method: 'POST',
      body: JSON.stringify({}),
    }),
  setNotifyDisabled: (notifyDisabled: boolean) =>
    apiFetch<{ ok: boolean; notifyDisabled: boolean }>('/api/changelog/preference', {
      method: 'POST',
      body: JSON.stringify({ notifyDisabled }),
    }),
};
